<template>
  <div class="map-info-container d-flex flex-grow-1">
    <div id="map-info" class="map-info flex-grow-1" style="border-radius:4px;"></div>
  </div>
</template>
<script>
import localIcon from '@/assets/images/work-order-detail/map/local-icon.png';

export default {
  name: 'map-info',
  props: {
    Mstate: {
      default: 0,
      type: Number,
    },
    warnInfo: {
      type: Object,
      default() {
        return {
          F_ProcessName: '银座好望角---6B1进线开关',
          ProjectName: '银座好望角',
          WarnGrade: '一般',
          WarningType: '',
          WarningRange: '局面',
          F_CreateDate: '2019-03-12 15:22:25',
          ChiXu: '',
          Lng: '117.010429382324',
          Lat: '36.6744613647461',
          State: '未处理',
        };
      },
    },
  },
  data() {
    return {
      heatmap: '',
      mapCenter: [117.010429382324, 36.6745613647461],
      gInnerLocs: '',
      gOuterLocs: '',
      bermudaTriangle: null,
      isInnerReady: false,
      isOuterReady: false,
      infoWin: '',
    };
  },
  mounted() {
    this.initMap();
  },
  watch: {
    warnInfo: {
      deep: true,
      handler(newVal) {
        this.changeCenter(newVal);
      },
    },
    Mstate(a) {
      console.log(a);
      this.warnInfo.State = a;

      console.log(this.isState(a));
    },
    mapCenter: {
      deep: true,
      handler(newVal) {
        if (this.heatmap && newVal[1]) {
          this.heatmap.panTo(
            new window.T.LngLat(parseFloat(newVal[0]), parseFloat(newVal[1])),
          );
          this.initInfoWin();
        } else {
          this.initMap();
        }
      },
    },
  },
  methods: {
    // 根据处理状态数字判断是啥
    isState(a) {
      switch (a) {
        case 0:
          return '未处理';

        case 1:
          return '处理中';

        case 2:
          return '已处理';

        case 3:
          return '已忽略';
        default:
          return a;
      }
    },
    getZoomSize(type) {
      switch (type) {
        case 1:
          return 10;
        case 2:
          return 9;
        case 3:
          return 15;
        default:
          return 5;
      }
    },
    changeCenter(warnInfo) {
      this.mapCenter = [parseFloat(warnInfo.Lng), parseFloat(warnInfo.Lat)];
    },
    changeToGLocs(polyline) {
      const pointsArr = polyline.split(';');
      const gLocs = [];
      pointsArr.forEach((point) => {
        const pointArr = point.split(',');
        const gPoint = {
          lng: parseFloat(pointArr[0]),
          lat: parseFloat(pointArr[1]),
        };
        gLocs.push(gPoint);
      });
      this.gInnerLocs = gLocs;
    },
    initMap() {
      const imageURL = 'http://t0.tianditu.gov.cn/img_w/wmts?'
        + 'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles'
        + '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=0b9199b328f9862d3ec9c14d8c020f19';
      const lay = new window.T.TileLayer(imageURL, { minZoom: 1, maxZoom: 18 });
      this.heatmap = new window.T.Map('map-info', {
        center: new window.T.LngLat(this.mapCenter[0], this.mapCenter[1]),
        minZoom: 10,
        maxZoom: 18,
        zoom: 17,
        layers: [lay],
      });
      this.initInfoWin();
    },
    initInfoWin() {
      if (this.infoWin) {
        this.heatmap.removeOverLay(this.infoWin);
        this.infoWin = '';
      }
      const infoContainer = document.createElement('div');
      infoContainer.className = 'd-flex flex-column align-items-stretch';
      const infoMainContainer = document.createElement('div');
      infoMainContainer.className = 'warn-info';
      const titleContainer = document.createElement('div');
      titleContainer.className = 'info-top d-flex justify-content-between align-items-center';
      const titleD = document.createElement('div');
      const closeX = document.createElement('img');
      titleD.className = 'pl-2';
      closeX.className = 'm-2 ml-4 align-self-start';
      titleD.innerHTML = `<div style="font-weight:bold;">${this.warnInfo.F_ProcessName}</div>`;
      titleContainer.appendChild(titleD);
      titleContainer.appendChild(closeX);
      closeX.onclick = this.closeInfoWindow;
      infoMainContainer.appendChild(titleContainer);
      const contentContainer = document.createElement('div');
      contentContainer.className = 'py-1 px-2';
      const contentString = `
      <div class="d-flex warn-content"><div>告警时间:</div><div>${
  this.warnInfo.F_CreateDate
}</div></div>
      <div class="d-flex warn-content"><div>告警类型:</div><div>${
  this.warnInfo.WarningReason
}</div></div>
      <div class="d-flex warn-content"><div>告警级别:</div><div>${
  this.warnInfo.WarnGrade
}</div></div>
      <div class="d-flex warn-content"><div>状态:</div><div>${this.isState(
    this.warnInfo.State,
  )}</div></div>`;
      contentContainer.innerHTML = contentString;
      infoMainContainer.appendChild(contentContainer);
      infoContainer.appendChild(infoMainContainer);
      this.infoWin = new window.T.InfoWindow();
      this.infoWin.setContent(infoContainer);
      this.infoWin.setLngLat(
        new window.T.LngLat(this.mapCenter[0], this.mapCenter[1]),
      );
      this.infoWin.setOffset(new window.T.Point(5, -10));
      // 显示详情点击事件
      this.heatmap.addOverLay(this.infoWin);
      this.addMapIcon();
    },
    addMapIcon() {
      // 创建图片对象
      const icon = new window.T.Icon({
        iconUrl: localIcon,
        iconSize: new window.T.Point(30, 30),
        iconAnchor: new window.T.Point(10, 20),
      });
      // 向地图上添加自定义标注
      const marker = new window.T.Marker(
        new window.T.LngLat(this.mapCenter[0], this.mapCenter[1]),
        { icon },
      );
      this.heatmap.addOverLay(marker);
    },
    closeInfoWindow() {
      this.heatmap.clearInfoWindow();
    },
  },
};
</script>
<style >
.map-info,
.warn-info {
  color: rgb(101, 101, 247);
}
.warn-info {
  background-color: white !important;
}
.info-top {
  font-size: 16px;
  color: #474a4c;
}
.warn-content {
  color: #474a4c;
  font-size: 14px;
}
</style>
